import { render } from "./SortTemplate.vue?vue&type=template&id=5697adf8"
import script from "./SortTemplate.vue?vue&type=script&lang=js"
export * from "./SortTemplate.vue?vue&type=script&lang=js"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__